import React from 'react';

export const getOrdinalNumber = int => {
  const TH = 'th';
  const suffix = [11, 12, 13].includes(int % 100) ? TH : [TH, 'st', 'nd', 'rd', TH][Math.min(int % 10, 4)];
  return (
    <span>
      {int}
      <sup className="fw-bold">{suffix}</sup>
    </span>
  );
};
